export enum UseCase {
  SMART_CLEANING = 'smartCleaning',
  LEGIONELLA = 'legionella',
  COLD_STORAGE = 'coldStorage',
  ENERGY = 'energy',
  GATEWAY = 'gateway',
  AIR_QUALITY = 'airQuality',
  CONSUMPTIONS = 'consumptions',
}
